import { render } from "./register-stage-job-roles.vue?vue&type=template&id=f37dbde8&scoped=true"
import script from "./register-stage-job-roles.vue?vue&type=script&lang=js"
export * from "./register-stage-job-roles.vue?vue&type=script&lang=js"

import "./register-stage-job-roles.vue?vue&type=style&index=0&id=f37dbde8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37dbde8"]])

export default __exports__